var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "40px",
    viewBox: "0 0 45 40",
    style: {
      enableBackground: "new 0 0 45 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,14.2c0-2.9-1-5.7-3.4-7.5C28,6.7,28,7,28.1,7.1c1.1,1.2,1.7,4.5,1.7,6.2c0,3.7-3.3,6.6-7.2,6.7l0,0h-0.3l0,0 c-3.8-0.1-7.2-3-7.2-6.7c0-1.7,0.6-5,1.7-6.2C17,7,17,6.7,16.7,6.7c-2.3,1.8-3.4,4.6-3.4,7.5c0,5,4.1,9.1,9.1,9.1l0,0h0.2l0,0 C27.6,23.3,31.7,19.2,31.7,14.2 M38.6,14.8c0-4.5-2-8.5-5.4-11.4c-0.1,0-0.2,0.1-0.2,0.4c2.2,2.2,3.5,6.4,3.5,9.6 c0,6.9-6.2,12.6-13.8,12.6l0,0h-0.2l0,0c-7.6,0-13.8-5.7-13.8-12.6c0-3.2,1.3-7.4,3.5-9.6c0.1-0.3,0-0.4-0.2-0.4 c-3.5,2.9-5.5,6.9-5.5,11.4c0,8.4,6.6,15.9,16,15.9l0,0h0.2l0,0C32,30.7,38.6,23.2,38.6,14.8 M45,17.1c0-6.4-2.8-12.2-7.4-16.4 c-0.1,0-0.2,0.1-0.2,0.4C40.3,4.4,42,9.9,42,14.6c0,10.5-8.7,19-19.4,19l0,0h-0.2l0,0C11.7,33.6,3,25.1,3,14.6 C3,9.9,4.7,4.4,7.6,1.1c0.1-0.3,0-0.4-0.2-0.4C2.8,4.9,0,10.7,0,17.1c0,12.2,10,22.1,22.3,22.2l0,0h0.3C35,39.2,45,29.3,45,17.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsogo);
export default __webpack_public_path__ + "static/media/tsogo.1c4f02d2f92953fe810694aedc7929e4.svg";
export { ForwardRef as ReactComponent };